import React from 'react';
import { Link } from 'react-router-dom';

// import maleImg from './assets/male.png';
// import femaleImg from './assets/female.png';
// import unisexImg from './assets/unisex.png';

const genders = [
  {
    name: "For Her",
    image: "male.png",
    link: "/product?gender=male&menu=FOR%20HIM",
  },
  {
    name: "For Him",
    image: "female.png",
    link: "/product?gender=female",
  },
  {
    name: "Unisex",
    image: "unisex.png",
    link: "/product?gender=unisex",
  },
];

function ShopByGender() {
  return (
    <section className="mx-auto px-4 sm:px-6 lg:px-8 bg-[#F3F3FD] pb-8">
      <h2 className="text-center text-xl font-semibold py-8">SHOP BY GENDER</h2>

      <div className="flex justify-center">
        <div className="grid grid-cols-3 sm:grid-cols-3 md:grid-cols-3 gap-6 justify-items-center">
          {genders.map((recipient) => (
            <Link
              key={recipient.name}
              to={recipient.link}
              className="flex flex-col items-center cursor-pointer transform hover:scale-105 transition-transform duration-300 will-change-transform"
            >
              <img
                src={recipient.image}
                alt={recipient.name}
                width={300}
                height={440}
                className="w-full max-w-[300px] h-auto md:h-[460px] object-fill rounded-t-full"
                loading="lazy"
              />
              {/* <p className="mt-2 text-lg font-medium">{recipient.name}</p> */}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ShopByGender;
